module.exports = __webpack_public_path__ + "img/characterAnime8.f4884e63.png";